<template>
  <router-view />
</template>

<script>
export default {
  name: 'AllContentLayoutWhiteGlove',
}
</script>
